import n, { useRef as r, useState as e, useMemo as t, useEffect as o } from "react";
import i from "prop-types";
import { css as a, cx as u } from "@leafygreen-ui/emotion";
import { useIsomorphicLayoutEffect as c } from "@leafygreen-ui/hooks";
import l, { variantColors as f, Language as d } from "@leafygreen-ui/syntax";
export { Language } from "@leafygreen-ui/syntax";
import p from "@leafygreen-ui/icon/dist/Checkmark";
import s from "@leafygreen-ui/icon/dist/Copy";
import m from "@leafygreen-ui/icon-button";
import { darken as g } from "polished";
import h from "lodash/debounce";
import { uiColors as b } from "@leafygreen-ui/palette";
import v from "clipboard";

function y(n, r, e) {
  return r in n ? Object.defineProperty(n, r, {
    value: e,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : n[r] = e, n;
}

function x() {
  return (x = Object.assign || function (n) {
    for (var r = 1; r < arguments.length; r++) {
      var e = arguments[r];

      for (var t in e) {
        Object.prototype.hasOwnProperty.call(e, t) && (n[t] = e[t]);
      }
    }

    return n;
  }).apply(this, arguments);
}

function w(n, r) {
  if (null == n) return {};

  var e,
      t,
      o = function (n, r) {
    if (null == n) return {};
    var e,
        t,
        o = {},
        i = Object.keys(n);

    for (t = 0; t < i.length; t++) {
      e = i[t], r.indexOf(e) >= 0 || (o[e] = n[e]);
    }

    return o;
  }(n, r);

  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(n);

    for (t = 0; t < i.length; t++) {
      e = i[t], r.indexOf(e) >= 0 || Object.prototype.propertyIsEnumerable.call(n, e) && (o[e] = n[e]);
    }
  }

  return o;
}

function k(n, r) {
  return r || (r = n.slice(0)), Object.freeze(Object.defineProperties(n, {
    raw: {
      value: Object.freeze(r)
    }
  }));
}

function O(n, r) {
  return function (n) {
    if (Array.isArray(n)) return n;
  }(n) || function (n, r) {
    if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(n))) return;
    var e = [],
        t = !0,
        o = !1,
        i = void 0;

    try {
      for (var a, u = n[Symbol.iterator](); !(t = (a = u.next()).done) && (e.push(a.value), !r || e.length !== r); t = !0) {
        ;
      }
    } catch (n) {
      o = !0, i = n;
    } finally {
      try {
        t || null == u.return || u.return();
      } finally {
        if (o) throw i;
      }
    }

    return e;
  }(n, r) || function (n, r) {
    if (!n) return;
    if ("string" == typeof n) return N(n, r);
    var e = Object.prototype.toString.call(n).slice(8, -1);
    "Object" === e && n.constructor && (e = n.constructor.name);
    if ("Map" === e || "Set" === e) return Array.from(n);
    if ("Arguments" === e || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e)) return N(n, r);
  }(n, r) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

function N(n, r) {
  (null == r || r > n.length) && (r = n.length);

  for (var e = 0, t = new Array(r); e < r; e++) {
    t[e] = n[e];
  }

  return t;
}

function E() {
  var n = k(["\n          background-color: ", ";\n          color: ", ";\n        "]);
  return E = function E() {
    return n;
  }, n;
}

function j() {
  var n = k(["\n        height: ", "px;\n        width: ", "px;\n        border-radius: 50px;\n        margin-right: 8px;\n        background-color: ", ";\n        border: 1px solid ", ";\n      "]);
  return j = function j() {
    return n;
  }, n;
}

function C() {
  var n = k(["\n  padding-left: ", "px;\n  padding-right: ", "px;\n  font-size: 14px;\n"]);
  return C = function C() {
    return n;
  }, n;
}

function T() {
  var n = k(["\n  height: ", "px;\n  width: ", "px;\n"]);
  return T = function T() {
    return n;
  }, n;
}

function S() {
  var n = k(["\n  display: flex;\n  height: ", "px;\n"]);
  return S = function S() {
    return n;
  }, n;
}

function L() {
  var n = k(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: ", "px;\n  padding-left: ", "px;\n  padding-right: ", "px;\n  border-radius: ", "px ", "px 0 0;\n"]);
  return L = function L() {
    return n;
  }, n;
}

var M = "light",
    W = "dark",
    A = a(L(), 28, 12, 12, 4, 4),
    P = a(S(), 12),
    I = a(T(), 12, 60),
    z = a(C(), 8, 8);

function F(r) {
  var e = r.color;
  return n.createElement("div", {
    className: a(j(), 12, 12, e, g(.03, e))
  });
}

function q(r) {
  var e = r.darkMode,
      t = void 0 !== e && e,
      o = r.chromeTitle,
      i = void 0 === o ? "" : o,
      c = f[t ? W : M];
  return n.createElement("div", {
    className: u(A, a(E(), c[1], c[2]))
  }, n.createElement("div", {
    className: P
  }, ["#FF5952", "#E7BF2A", "#54C22C"].map(function (r) {
    return n.createElement(F, {
      key: r,
      color: r
    });
  })), n.createElement("div", {
    className: z
  }, i), n.createElement("div", {
    className: I
  }));
}

function B() {
  var n = k(["\n          display: flex;\n        "]);
  return B = function B() {
    return n;
  }, n;
}

function R() {
  var n = k(["\n    ", ";\n    border-radius: 4px;\n    overflow: hidden;\n  "]);
  return R = function R() {
    return n;
  }, n;
}

function U() {
  var n = k(["\n      box-shadow: inset -6px 0 6px -6px ", ";\n    "]);
  return U = function U() {
    return n;
  }, n;
}

function $() {
  var n = k(["\n      box-shadow: inset 6px 0 6px -6px ", ";\n    "]);
  return $ = function $() {
    return n;
  }, n;
}

function D() {
  var n = k(["\n      box-shadow: inset 6px 0 6px -6px ", ",\n        inset -6px 0 6px -6px ", ", inset 0 6px 6px -6px ", ",\n        inset 0 -6px 6px -6px ", ";\n    "]);
  return D = function D() {
    return n;
  }, n;
}

function G() {
  var n = k(["\n        background-color: ", ";\n      "]);
  return G = function G() {
    return n;
  }, n;
}

function H() {
  var n = k(["\n        color: ", ";\n        background-color: ", ";\n\n        &:focus {\n          color: ", ";\n\n          &:before {\n            background-color: ", ";\n          }\n        }\n\n        &:hover {\n          color: ", ";\n\n          &:before {\n            background-color: ", ";\n          }\n        }\n      "]);
  return H = function H() {
    return n;
  }, n;
}

function J() {
  var n = k(["\n    align-self: center;\n    color: ", ";\n  "]);
  return J = function J() {
    return n;
  }, n;
}

function K() {
  var n = k(["\n        border-color: ", ";\n        background-color: ", ";\n      "]);
  return K = function K() {
    return n;
  }, n;
}

function Q() {
  var n = k(["\n        border-color: ", ";\n        background-color: white;\n      "]);
  return Q = function Q() {
    return n;
  }, n;
}

function V() {
  var n = k(["\n    ", ";\n    background-color: ", ";\n    color: ", ";\n  "]);
  return V = function V() {
    return n;
  }, n;
}

function X() {
  var n = k(["\n  padding: 10px;\n"]);
  return X = function X() {
    return n;
  }, n;
}

function Y() {
  var n = k(["\n  width: 38px;\n  border-left: solid 1px;\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 0;\n  padding-top: 6px;\n"]);
  return Y = function Y() {
    return n;
  }, n;
}

function Z() {
  var n = k(["\n  border-left: 0;\n"]);
  return Z = function Z() {
    return n;
  }, n;
}

function _() {
  var n = k(["\n  overflow-x: auto;\n  border-left: 2px solid;\n  // We apply left / right padding in Syntax to support line highlighting\n  padding-top: ", "px;\n  padding-bottom: ", "px;\n  margin: 0;\n  position: relative;\n  flex-grow: 1;\n"]);
  return _ = function _() {
    return n;
  }, n;
}

q.displayName = "WindowChrome", q.propTypes = {
  darkMode: i.bool,
  chromeTitle: i.string
};
var nn = "light",
    rn = "dark",
    en = a(_(), 12, 12),
    tn = a(Z()),
    on = a(Y()),
    an = a(X());

function un(n) {
  var r = f[n];

  switch (n) {
    case nn:
      return a(Q(), r[1]);

    case rn:
      return a(K(), r[1], r[1]);
  }
}

function cn(n, r) {
  var e = a(J(), b.gray.base);
  return r ? u(e, a(H(), b.white, b.green.base, b.white, b.green.base, b.white, b.green.base)) : n === rn ? u(e, a(G(), b.gray.dark3)) : e;
}

var ln = "none",
    fn = "left",
    dn = "right",
    pn = "both";

function sn(i) {
  var d = i.children,
      g = void 0 === d ? "" : d,
      b = i.className,
      k = i.language,
      N = i.darkMode,
      E = void 0 !== N && N,
      j = i.showLineNumbers,
      C = void 0 !== j && j,
      T = i.showWindowChrome,
      S = void 0 !== T && T,
      L = i.chromeTitle,
      M = void 0 === L ? "" : L,
      W = i.copyable,
      A = void 0 === W || W,
      P = i.onCopy,
      I = i.highlightLines,
      z = w(i, ["children", "className", "language", "darkMode", "showLineNumbers", "showWindowChrome", "chromeTitle", "copyable", "onCopy", "highlightLines"]),
      F = r(null),
      G = O(e(null), 2),
      H = G[0],
      J = G[1],
      K = O(e(ln), 2),
      Q = K[0],
      X = K[1],
      Y = O(e(!1), 2),
      Z = Y[0],
      _ = Y[1],
      sn = O(e(!1), 2),
      mn = sn[0],
      gn = sn[1],
      hn = E ? rn : nn,
      bn = t(function () {
    return g.includes("\n");
  }, [g]);
  o(function () {
    gn(!S && A && v.isSupported());
  }, [A, S]), o(function () {
    if (H) {
      var n = new v(H, {
        text: function text() {
          return g;
        }
      });

      if (Z) {
        var r = setTimeout(function () {
          _(!1);
        }, 1500);
        return function () {
          return clearTimeout(r);
        };
      }

      return function () {
        return n.destroy();
      };
    }
  }, [H, g, Z]), c(function () {
    var n = F.current;
    null != n && n.scrollWidth > n.clientWidth && X(dn);
  }, []);
  var vn = u(en, function (n) {
    var r = f[n],
        e = "dark" === n ? "border: 0" : "border-color: ".concat(r[1]);
    return a(V(), e, r[0], r[3]);
  }(hn), y({}, tn, S), b, function (n, r) {
    var e = f[r],
        t = r === nn ? "rgba(93,108,116,0.3)" : "rgba(0,0,0,0.35)";
    return n === pn ? a(D(), t, t, e[0], e[0]) : n === fn ? a($(), t) : n === dn ? a(U(), t) : "";
  }(Q, hn)),
      yn = n.createElement(l, {
    showLineNumbers: C,
    darkMode: E,
    language: k,
    highlightLines: I
  }, g);
  var xn = h(function (n) {
    var r = n.target,
        e = r.scrollWidth,
        t = r.clientWidth;

    if (e > t) {
      var o = n.target.scrollLeft,
          i = e - t;
      o > 0 && o < i ? X(pn) : o > 0 ? X(fn) : o < i && X(dn);
    }
  }, 50, {
    leading: !0
  }),
      wn = E ? "border: 0" : "border: 1px solid ".concat(f[hn][1]),
      kn = a(R(), wn),
      On = mn && n.createElement("div", {
    className: u(on, y({}, an, !bn), un(hn))
  }, n.createElement(m, {
    ref: J,
    darkMode: E,
    "aria-label": "Copy",
    className: cn(hn, Z),
    onClick: function onClick() {
      P && P(), _(!0);
    }
  }, Z ? n.createElement(p, null) : n.createElement(s, null)));
  return n.createElement("div", {
    className: kn
  }, S && n.createElement(q, {
    chromeTitle: M,
    darkMode: E
  }), n.createElement("div", {
    className: a(B())
  }, n.createElement("pre", x({}, z, {
    className: vn,
    onScroll: function onScroll(n) {
      n.persist(), xn(n);
    },
    ref: F
  }), yn), On));
}

sn.displayName = "Code", sn.propTypes = {
  children: i.string.isRequired,
  language: i.oneOf(Object.values(d)),
  darkMode: i.bool,
  className: i.string,
  showLineNumbers: i.bool,
  showWindowChrome: i.bool,
  chromeTitle: i.string,
  highlightLines: i.arrayOf(i.oneOfType([i.arrayOf(i.number), i.number]))
};
export default sn;